import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';
import { transformToClientAccessList } from '../../utils/screenPermission';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchOrderRequest = async (
  {
    requesterIDs,
    orderName,
    dueDateFrom,
    dueDateTo,
    rushOrder,
    statusIDs,
    clientIDs,
    reportAddressIDs,
    scenarioIDs,
    supplyTypeIDs,
    flags,
    isRecurring,
    functionality,
    orderNumber,
    page,
    pageSize,
    sortBy,
  }
) => {
  const queryParams = [];
  const clientAccessFilter = transformToClientAccessList(clientIDs, reportAddressIDs, scenarioIDs);
  if (orderName) {
    queryParams.push(`orderName=${encodeURIComponent(orderName)}`);
    queryParams.push('orderNameOP=Contains');
  }

  if (orderNumber) {
    queryParams.push(`orderNumber=${encodeURIComponent(orderNumber)}`);
  }
  if (requesterIDs) {
    queryParams.push(`requesterIDs=${encodeURIComponent(requesterIDs?.id)}`);
  }
  if (dueDateFrom) {
    queryParams.push(`dueDateFrom=${encodeURIComponent(dueDateFrom)}`);
  }
  if (dueDateTo) {
    queryParams.push(`dueDateTo=${encodeURIComponent(dueDateTo)}`);
  }

  if (rushOrder) {
    queryParams.push(`rushOrder=${encodeURIComponent(rushOrder)}`);
  }
  if (flags) {
    queryParams.push(`flags=${encodeURIComponent(flags)}`);
  }
  if (isRecurring) {
    queryParams.push(`isRecurring=${encodeURIComponent(isRecurring)}`);
  }
  if (statusIDs) {
    queryParams.push(`statusIDs=${statusIDs?.id}`);
  }
  if (clientAccessFilter) {
    queryParams.push(`clientAccessFilter=${encodeURIComponent(JSON.stringify(clientAccessFilter))}`);
  }
  // if (clientIDs.length) {
  //   queryParams.push(`clientIDs=${clientIDs?.map((client) => client.ClientID || client).join(',')}`);
  // }
  if (supplyTypeIDs.length) {
    queryParams.push(`supplyTypeIDs=${supplyTypeIDs?.map((sub) => sub?.id).join(',')}`);
  }
  if (functionality) {
    queryParams.push(`functionality=${encodeURIComponent(functionality)}`);
  }
  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/OrderRequest/Search/By?${queryParams.join('&')}`
    );

    return response.data;
    // return data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const createOrderRequest = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      '/OrderRequest/Create',
      requestPayload
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const OrderRequestUpdate = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      '/OrderRequest/Save',
      requestPayload
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getOrderRequestByOrderRequestId = async (orderRequestID) => {
  try {
    const response = await axiosInstance.get(`/OrderRequest/OrderRequestID/${orderRequestID}`);
    return response.data;
  } catch (e) {
    throw new Error('Error getOrderRequestByOrderRequestId');
  }
};
const cancelOrderRequest = async (orderRequestID) => {
  try {
    const response = await axiosInstance.post('/OrderRequest/UpdateOrderRequestAction', {
      OrderRequestID: orderRequestID,
      Action: 'Cancel'
    });
    return response.data;
  } catch (e) {
    throw new Error('Error cancelOrderRequest');
  }
};
const OrderRequestApi = {
  searchOrderRequest,
  createOrderRequest,
  OrderRequestUpdate,
  getOrderRequestByOrderRequestId,
  cancelOrderRequest
};

export default OrderRequestApi;
